"use client";

import { useParams } from "next/navigation";
import React, { useEffect, useState } from "react";

import { ChainName } from "@/shared/types/networks";
import { request } from "@/shared/utils/request";

import { ChainIdContext } from "./context";

export interface ChainSearchResponse {
  chainInfo: {
    chainId: number;
    name: string;
    chainRpcUrl: string;
    publicChainId: number;
  };
}

const chainIdByChainName: Record<ChainName, number> = {
  [ChainName.Arbitrum]: 42161,
  [ChainName.ArbitrumGoerli]: 421613,
  [ChainName.PolygonMumbai]: 80001,
};

export function ChainIdProvider({ children }: { children: React.ReactNode }) {
  const [chainId, setChainIdId] = useState<number>();
  const { chain: chainName } = useParams<{ chain: ChainName }>();

  const publicChainId = chainIdByChainName[chainName];

  useEffect(() => {
    const abortController = new AbortController();
    const fetchChainSearch = async () => {
      const response = await request<ChainSearchResponse>(
        `chain/search?publicChainId=${publicChainId}`,
        { signal: abortController.signal },
      );
      setChainIdId(response.chainInfo.chainId);
    };
    fetchChainSearch();
    return () => {
      abortController.abort();
    };
  }, [publicChainId]);

  return (
    <ChainIdContext.Provider value={{ chainId }}>
      {children}
    </ChainIdContext.Provider>
  );
}
